export default __webpack_public_path__ + "4b6a0267477d2060557ec299d455494b.png";